import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function WebhookActionNode({ id, data }) {
    return (
        <NodeComponent title="Webhook Action" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

